import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { BaseInjector } from './base-injector.service';
import 'rxjs/add/observable/throw';
export class BaseService {
  public toastr: ToastrService;
  /**
   *
   */
  constructor() {
    this.toastr = BaseInjector.injector.get(ToastrService);
  }

  // getAll() {
  //  return this.http.get(this.url).pipe(
  //    map((res: Response) => res.json()),
  //    catchError(this.errorHandler)
  //  );
  // }

  // getById(id) {
  //  return this.http.get(`${this.url}/${id}`).pipe(
  //    map((res: Response) => res.json()),
  //    catchError(this.errorHandler)
  //  );
  // }

  // create(resource) {
  //  return this.http.post(this.url, resource).pipe(
  //    map((res: Response) => res.json()),
  //    catchError(this.errorHandler)
  //  );
  // }

  // Update(resource) {
  //  return this.http.put(`${this.url}/${resource.id}`, resource).pipe(
  //    map((res: Response) => res.json()),
  //    catchError(this.errorHandler)
  //  );
  // }

  // Delete(resource) {
  //  return this.http.delete(`${this.url}/${resource.id}`, resource);
  // }

  errorHandler(error: any) {
    //  if (error.status === 404) return Observable.throw(new NotFoundError());

    //  if (error.status === 400) return Observable.throw(new BadInputError(error));

    //  if (error.status === 401)
    //    return Observable.throw(new UnAuthrizederror(error));

    //  return Observable.throw(new AppError(error));

    const errorSt = error.headers.get('application-error') || error.error;
    return Observable.throwError(errorSt);
  }
}
